'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Common.TrendIndicator', []).directive('rmTrendIndicator', require('./directives/TrendIndicatorDirective'));